import {HttpCode} from '../../Constant/HttpCode';
import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  SOMETHING_WENT_WRONG,
  ADD_ATTENDEE,
  SHOW_MESSAGE,
  UPDATE_ATTENDEES_BY_ID,
  VERIFY_COUPONCODES,
  APPLY_COUPONCODES,
  PAYMENT_EVENT_REGISTRATION_BY_EVENT_ID,
  GET_ALL_REGISTRATION,
  UPDATE_REGISTRATION_OPTOINS_BY_ID,
  GET_ALL_WAITING_LIST,
  GET_ALL_WAITING_LIST_CSV_DOWNLOAD,
  UPDATE_SPONOSOR_BY_ID,
  POST_EVENT_PAYMENT_SUCCESS,
  RESET_EVENT_PAYMENT,
  PAYMENT_EVENT_REGISTRATION_CLIENT_KEYS,
  CANCEL_GROUP_OF_REGISTRATION_BY_EVENT_ID,
  MEMORIZED_REFUND_ATTENDEES,
  GET_ALL_REGISTRATION_CSV_DOWNLOAD,
  RESET_MEMORIZED_REFUND_ATTENDEES,
  SET_COUPONCODES_ERROR_MESSAGE,
  GET_ALL_ATTENDEES_BY_TRANSACTION_ID,
  GET_ALL_EVENT_SPONSORS_LOGOS,
  GET_ALL_USER_WAITING_LIST,
  FETCH_EVENT_DATA,
  ADD_NOTE_BY_EVENT_REGISTRATION_SUCCESS,
} from '../../Constant/ActionTypes';
import {commonSortOrder, handleJwtExpireMsg, scrollAndFocusFormErrorField} from '../../Util/commonUtility';
import Urls from '../../Constant/Urls';
import {httpClient} from '../../Api/client';
import {
  GET_ALL_ATTENDEES_BY_USER_EVENTID,
  DELETE_ATTENDEES_BY_ID,
} from './../../Constant/ActionTypes';
import {setEventNameState, setPaymentRoute} from './chapters';

export const postAttendee = (
  Data,
  setEditingKey,
  form,
  setIsAddAttendee,
  setDisableAttendeeClicks,
  setDisablePaymentClicks,
  setDisableEditClicks,
  setIsSavingAttendee,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.post(Urls.ADD_ATTENDEE, Data);
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: ADD_ATTENDEE});
        setEditingKey && setEditingKey('');
        form && form.resetFields();
        setIsAddAttendee && setIsAddAttendee(false);
        setDisableAttendeeClicks && setDisableAttendeeClicks(false);
        setDisablePaymentClicks && setDisablePaymentClicks(false);
        setDisableEditClicks && setDisableEditClicks(false);
        setIsSavingAttendee && setIsSavingAttendee(false);
        if (
          typeof data?.data?.message === 'string' &&
          data.data.message.toLowerCase().includes('waiting list')
        ) {
          dispatch({type: SHOW_MESSAGE, payload: data.data.message});
        }
        return true;
      } 
      setIsSavingAttendee && setIsSavingAttendee(false);
      return false;
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.BadRequest:
          errorMessage =
            (error?.response?.data?.errorsValidation?.length
              ? error.response.data.errorsValidation[0]?.matches
              : null) || error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.NotFound:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      // Keep the draft row and form values so the user can fix the email (or other
      // field) without retyping everything after a duplicate-email rejection.
      setIsSavingAttendee && setIsSavingAttendee(false);
      setDisableAttendeeClicks && setDisableAttendeeClicks(false);
      setDisablePaymentClicks && setDisablePaymentClicks(false);
      if (errorMessage === 'Validation Error' && form) {
        dispatch({type: FETCH_SUCCESS});
        const firstEmptyField = [
          'attendee_first_name',
          'attendee_last_name',
          'attendee_email',
          'attendee_email_confirm',
          'registration_option',
          'food_option',
          'attendee_company',
          'attendee_department',
          'attendee_job_title',
        ].find((name) => {
          const value = form.getFieldValue(name);
          return value == null || (typeof value === 'string' && !value.trim());
        });
        scrollAndFocusFormErrorField(firstEmptyField || 'attendee_company', form);
        return false;
      }
      dispatch({type: FETCH_ERROR, payload: errorMessage});
      return false;
    }
  };
};
export const verifyCouponCodes = (code, eventId, setCouponVerified) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.get(
        Urls.COUPONCODES_VERIFY.replace('#{couponCode}', code).replace(
          '#{eventId}',
          eventId,
        ),
      );

      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: SHOW_MESSAGE, payload: data?.data?.message});
        dispatch({type: VERIFY_COUPONCODES});
        setCouponVerified && setCouponVerified(true);
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.NotFound:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const applyCouponCodes = (Data, setIsAppliedCoupon) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      const payload = {
        ...Data,
        ...(typeof Data?.code === 'string' && {code: Data.code.trim()}),
        ...(typeof Data?.coupon_code === 'string' && {
          coupon_code: Data.coupon_code.trim(),
        }),
      };
      let data = await httpClient.post(Urls.COUPONCODES_APPLY, payload);
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: SHOW_MESSAGE,
          payload: data?.data?.message,
        });
        dispatch({type: APPLY_COUPONCODES});
        setIsAppliedCoupon && setIsAppliedCoupon(true);
      }
    } catch (error) {
      let errorMessage = '';
      switch (error.response?.status) {
        case HttpCode.NotFound:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      dispatch({type: SET_COUPONCODES_ERROR_MESSAGE, payload: errorMessage});
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const getAllEventSponsorLogos = () => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.get(Urls.GET_ALL_SPONSORS_LOGOS);
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: GET_ALL_EVENT_SPONSORS_LOGOS,
          payload: data?.data?.data,
        });
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.NotFound:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const getAttendesByUserAndEventId = (
  id,
  attendeeType,
  includeProcessingFee = false,
  parentSponsorId,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      const parentQuery = parentSponsorId
        ? `&parent_sponsor_id=${parentSponsorId}`
        : '';
      let data = await httpClient.get(
        `${Urls.GET_ALL_ATTENDEE.replace('#{eventId}', id).replace(
          '#{attendeeType}',
          attendeeType,
        )}?includeProcessingFee=${includeProcessingFee}${parentQuery}`,
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: GET_ALL_ATTENDEES_BY_USER_EVENTID,
          payload: data?.data,
        });
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.NotFound:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

/**
 * Fresh cart fetch for qualification checks. Updates Redux and returns attendees
 * so callers do not rely on stale in-memory cart state.
 */
export const fetchAttendeesForQualificationCheck = (
  eventId,
  attendeeType = 'normal',
) => {
  return async (dispatch) => {
    try {
      const data = await httpClient.get(
        `${Urls.GET_ALL_ATTENDEE.replace('#{eventId}', eventId).replace(
          '#{attendeeType}',
          attendeeType,
        )}?includeProcessingFee=false`,
      );
      if (data?.status !== HttpCode.Ok) {
        return null;
      }
      dispatch({
        type: GET_ALL_ATTENDEES_BY_USER_EVENTID,
        payload: data?.data,
      });
      const payload = data?.data?.data ?? data?.data;
      return payload?.event_registrations?.attendees ?? [];
    } catch {
      return null;
    }
  };
};

/** Poll cart until all listed registrations have qualification_form_submitted_at set. */
export const pollQualificationStatus = (
  eventId,
  registrationIds,
  maxWaitMs = 60000,
  intervalMs = 2000,
) => {
  return async (dispatch) => {
    if (!registrationIds?.length) return true;

    const isAllConfirmed = (attendees) =>
      registrationIds.every((regId) => {
        const attendee = (attendees ?? []).find(
          (item) => Number(item.id) === Number(regId),
        );
        return !!attendee?.qualification_form_submitted_at;
      });

    const deadline = Date.now() + maxWaitMs;
    while (Date.now() < deadline) {
      try {
        const data = await httpClient.get(
          `${Urls.GET_ALL_ATTENDEE.replace('#{eventId}', eventId).replace(
            '#{attendeeType}',
            'normal',
          )}?includeProcessingFee=false`,
        );
        if (data?.status === HttpCode.Ok) {
          // Axios body is { message, data }; attendees live under data.data
          const payload = data?.data?.data ?? data?.data;
          const attendees = payload?.event_registrations?.attendees ?? [];

          if (isAllConfirmed(attendees)) {
            dispatch({
              type: GET_ALL_ATTENDEES_BY_USER_EVENTID,
              // Keep same shape as getAttendesByUserAndEventId (axios body)
              payload: data?.data,
            });
            return true;
          }
        }
      } catch {
        // Keep polling until timeout.
      }
      await new Promise((resolve) => setTimeout(resolve, intervalMs));
    }

    // Final check after timeout — covers submit that landed just as the wait ended.
    const finalAttendees = await dispatch(
      fetchAttendeesForQualificationCheck(eventId),
    );
    return isAllConfirmed(finalAttendees);
  };
};

export const getAttendeesByTransactionId = (transactionId) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.get(
        Urls.GET_ALL_ATTENDEE_TRANSACTION_ID.replace(
          '#{transactionId}',
          transactionId,
        ),
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: GET_ALL_ATTENDEES_BY_TRANSACTION_ID,
          payload: data?.data,
        });
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.NotFound:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

// Sponsor Registration
export const ADDED_REPS_PARENT_STORAGE_KEY = 'pbssAddedRepsParentSponsorId';

export const rememberAddedRepsParent = (parentSponsorId) => {
  if (parentSponsorId) {
    sessionStorage.setItem(
      ADDED_REPS_PARENT_STORAGE_KEY,
      String(parentSponsorId),
    );
  }
};

export const clearAddedRepsParent = () => {
  sessionStorage.removeItem(ADDED_REPS_PARENT_STORAGE_KEY);
};

export const readAddedRepsParent = () => {
  const value = sessionStorage.getItem(ADDED_REPS_PARENT_STORAGE_KEY);
  const parentId = Number(value);
  return Number.isFinite(parentId) && parentId > 0 ? parentId : undefined;
};

export const sponsorRegistrationByUserAndEventId = (
  id,
  navigate,
  priceBasedNav = false,
  optionId,
  addProcessingFee = false,
  skipNavigate = false,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      const parentSponsorId = readAddedRepsParent();
      let data = await httpClient.patch(
        Urls.PAYMENT_UPDATE_BY_EVENT_ID.replace('#{eventId}', id),
        {
          addProcessingFee,
          ...(parentSponsorId ? {parent_sponsor_id: parentSponsorId} : {}),
        },
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: PAYMENT_EVENT_REGISTRATION_BY_EVENT_ID,
          payload: data?.data,
        });
        dispatch(setPaymentRoute(`eventSponsor`));
        dispatch({
          type: PAYMENT_EVENT_REGISTRATION_CLIENT_KEYS,
          payload: data?.data?.data,
        });
        if (!skipNavigate) {
          priceBasedNav
            ? navigate(`/paymentSuccess/myEvents/sponsorship`)
            : navigate(`/payment/sponsor/${id}/${optionId}`);
        }
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.BadRequest:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

// Normal Registration
export const normalRegistrationByUserAndEventId = (
  id,
  navigate,
  priceBasedNav = false,
  addProcessingFee = false,
  skipNavigate = false,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.patch(
        Urls.PAYMENT_UPDATE_NORMAL_REGISTRATION_BY_EVENT_ID.replace(
          '#{eventId}',
          id,
        ),
        {addProcessingFee},
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: PAYMENT_EVENT_REGISTRATION_BY_EVENT_ID,
          payload: data?.data,
        });
        dispatch(setPaymentRoute(`addAttendees`));
        dispatch({
          type: PAYMENT_EVENT_REGISTRATION_CLIENT_KEYS,
          payload: data?.data?.data,
        });
        if (!skipNavigate) {
          priceBasedNav
            ? navigate(`/paymentSuccess/myEvents/regular`)
            : navigate(`/payment/normal/${id}`);
        }
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const deleteAttendee = (id) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.delete(
        Urls.DELETE_ATTENDEE.replace('#{eventRegistrationId}', id),
      );

      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});

        dispatch({type: DELETE_ATTENDEES_BY_ID});
      }
    } catch (error) {
      let errorMessage = '';
      switch (error.response?.status) {
        case HttpCode.NotFound:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const moveWaitingListToRegistration = (
  waitingListId,
  onSuccess,
  onError,
  confirmOverCapacity = false,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      const data = await httpClient.patch(
        Urls.MOVE_WAITING_LIST_TO_REGISTRATION.replace(
          '#{waitingListId}',
          waitingListId,
        ),
        confirmOverCapacity ? {confirm_over_capacity: true} : {},
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: SHOW_MESSAGE,
          payload:
            data?.data?.message ||
            'Attendee moved to event registration successfully.',
        });
        onSuccess && onSuccess();
        return {success: true};
      }
      return {success: false};
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.NotFound:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.BadRequest:
          errorMessage =
            error?.response?.data?.errorsValidation?.[0]?.matches ||
            error?.response?.data?.errorMessage;
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Conflict:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      const errors = error?.response?.data?.errors;
      const requiresOverCapacityConfirmation =
        error?.response?.status === HttpCode.Conflict &&
        Array.isArray(errors) &&
        errors.includes('OVER_CAPACITY_CONFIRMATION_REQUIRED');
      if (requiresOverCapacityConfirmation) {
        dispatch({type: FETCH_SUCCESS});
        onError && onError();
        return {
          success: false,
          requiresOverCapacityConfirmation: true,
          errorMessage,
        };
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
      onError && onError();
      return {success: false};
    }
  };
};

export const cancelWaitingListEntry = (waitingListId, onSuccess, onError) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      const data = await httpClient.patch(
        Urls.CANCEL_WAITING_LIST_ENTRY.replace(
          '#{waitingListId}',
          waitingListId,
        ),
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: SHOW_MESSAGE,
          payload:
            data?.data?.message ||
            'Waiting list entry cancelled successfully.',
        });
        onSuccess && onSuccess();
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.NotFound:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.BadRequest:
          errorMessage =
            error?.response?.data?.errorsValidation?.[0]?.matches ||
            error?.response?.data?.errorMessage;
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
      onError && onError();
    }
  };
};

/**
 * Admin only: Delete a registration with status "To Be Paid".
 * On success, call onSuccess (e.g. refetch list).
 */
export const deleteToBePaidRegistration = (registrationId, onSuccess) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      const data = await httpClient.delete(
        Urls.ADMIN_DELETE_TO_BE_PAID_REGISTRATION.replace(
          '#{eventRegistrationId}',
          registrationId,
        ),
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        onSuccess && onSuccess();
      }
    } catch (error) {
      let errorMessage = '';
      switch (error.response?.status) {
        case HttpCode.NotFound:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.BadRequest:
          errorMessage =
            error?.response?.data?.errorsValidation?.[0] ||
            error?.response?.data?.errorMessage;
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const UpdateAttendee = (
  Data,
  id,
  setEditingKey,
  form,
  setDisableAttendeeClicks,
  setDisablePaymentClicks,
  setDisableEditClicks,
  setIsSavingAttendee,
  setIsAddAttendee,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.patch(
        Urls.UPDATE_ATTENDEE.replace('#{eventRegistrationId}', id),
        Data,
      );
      if (data?.status === HttpCode.Ok) {
        setEditingKey && setEditingKey('');
        form && form.resetFields();
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: UPDATE_ATTENDEES_BY_ID});
        dispatch({type: FETCH_EVENT_DATA});
        setDisableAttendeeClicks && setDisableAttendeeClicks(false);
        setDisablePaymentClicks && setDisablePaymentClicks(false);
        setDisableEditClicks && setDisableEditClicks(false);
        setIsAddAttendee && setIsAddAttendee(false);
        setIsSavingAttendee && setIsSavingAttendee(false);
        return true;
      }
      setIsSavingAttendee && setIsSavingAttendee(false);
      return false;
    } catch (error) {
      let errorMessage = '';
      switch (error.response?.status) {
        case HttpCode.BadRequest:
        case HttpCode.NotFound:
          errorMessage =
            (error?.response?.data?.errorsValidation?.length
              ? error.response.data.errorsValidation[0]?.matches
              : null) || error?.response?.data?.errorMessage;

          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage =
            error?.response?.data?.errorMessage || SOMETHING_WENT_WRONG;
          break;
      }
      setIsSavingAttendee && setIsSavingAttendee(false);
      setDisableAttendeeClicks && setDisableAttendeeClicks(false);
      setDisablePaymentClicks && setDisablePaymentClicks(false);
      if (errorMessage === 'Validation Error' && form) {
        dispatch({type: FETCH_SUCCESS});
        const firstEmptyField = [
          'attendee_first_name',
          'attendee_last_name',
          'attendee_email',
          'attendee_email_confirm',
          'registration_option',
          'food_option',
          'attendee_company',
          'attendee_department',
          'attendee_job_title',
        ].find((name) => {
          const value = form.getFieldValue(name);
          return value == null || (typeof value === 'string' && !value.trim());
        });
        scrollAndFocusFormErrorField(firstEmptyField || 'attendee_company', form);
        return false;
      }
      dispatch({type: FETCH_ERROR, payload: errorMessage});
      return false;
    }
  };
};

export const UpdateSponsorById = (
  Data,
  id,
  setEditDetails,
  onSuccess,
  onError,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.patch(
        Urls.SPONSOR_UPDATE.replace('#{sponsorId}', id),
        Data,
      );
      if (data?.status === HttpCode.Ok) {
        setEditDetails && setEditDetails(false);
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: SHOW_MESSAGE,
          payload: data?.data?.message,
        });
        dispatch({
          type: UPDATE_SPONOSOR_BY_ID,
        });
        onSuccess && onSuccess(data?.data);
      } else {
        onError && onError();
      }
    } catch (error) {
      let errorMessage = '';
      switch (error.response?.status) {
        case HttpCode.BadRequest:
          errorMessage =
            (error?.response?.data?.errorsValidation?.length
              ? error.response.data.errorsValidation[0]?.matches
              : null) || error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      dispatch({type: FETCH_ERROR, payload: errorMessage});
      onError && onError(error);
    }
  };
};

export const getAllRegistrationByQueryString = (
  pagination,
  sortField,
  sortOrder,
  searchQueryData,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.get(
        `${Urls.GET_ALL_REGISTRATION}?page=${pagination.page}&pageCount=${
          pagination.pageCount
        }&sortOrder=${commonSortOrder(
          sortOrder,
        )}&sortField=${sortField}&${searchQueryData}`,
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: GET_ALL_REGISTRATION, payload: data?.data});
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const getAllWaitingListByQueryString = (
  pagination,
  sortField,
  sortOrder,
  searchQueryData,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.get(
        `${Urls.GET_ALL_WAITING_LIST}?page=${pagination.page}&pageCount=${
          pagination.pageCount
        }&sortOrder=${commonSortOrder(
          sortOrder,
        )}&sortField=${sortField}&${searchQueryData}`,
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: GET_ALL_WAITING_LIST, payload: data?.data?.data});
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const getRegistrationWaitingListByIdForCSV = (
  sortField,
  sortOrder,
  searchQueryData,
  totalCount,
  id,
  setCSVDataLoading,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    setCSVDataLoading && setCSVDataLoading(true);

    try {
      let data = await httpClient.get(
        `${
          Urls.GET_ALL_WAITING_LIST
        }/${id}?page=1&pageCount=${totalCount}&sortOrder=${commonSortOrder(
          sortOrder,
        )}&sortField=${sortField}&${searchQueryData}`,
      );

      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: GET_ALL_WAITING_LIST_CSV_DOWNLOAD,
          payload: data?.data?.data,
        });
        setCSVDataLoading && setCSVDataLoading(false);
      }
    } catch (error) {
      setCSVDataLoading && setCSVDataLoading(false);

      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }

      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const resetEventRegisterCsvDownloadState = () => {
  return {
    type: GET_ALL_REGISTRATION_CSV_DOWNLOAD,
    payload: [],
  };
};
export const getRegistrationByIdForCSV = (
  sortField,
  sortOrder,
  searchQueryData,
  totalEventRegistrationCount,
  id,
  setCSVDataLoading,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    setCSVDataLoading && setCSVDataLoading(true);
    try {
      let data = await httpClient.get(
        `${
          Urls.GET_REGISTRATIONS_BY_EVENTID
        }/${id}?page=1&pageCount=${totalEventRegistrationCount}&sortOrder=${commonSortOrder(
          sortOrder,
        )}&sortField=${sortField}&${searchQueryData}`,
      );
      if (data?.status === HttpCode.Ok) {
        dispatch(setEventNameState(data?.data?.data?.event_name));
        dispatch({
          type: GET_ALL_REGISTRATION_CSV_DOWNLOAD,
          payload: data?.data,
        });
        setCSVDataLoading && setCSVDataLoading(false);
      }
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        return data?.data;
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};
export const getRegistrationById = (
  pagination,
  sortField,
  sortOrder,
  searchQueryData,
  id,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.get(
        `${Urls.GET_REGISTRATIONS_BY_EVENTID}/${id}?page=${
          pagination.page
        }&pageCount=${pagination.pageCount}&sortOrder=${commonSortOrder(
          sortOrder,
        )}&sortField=${sortField}&${searchQueryData}`,
      );
      if (data?.status === HttpCode.Ok) {
        dispatch(setEventNameState(data?.data?.data?.event_name));
        dispatch({type: GET_ALL_REGISTRATION, payload: data?.data});
      }
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        return data?.data;
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const getRegistrationWaitingListById = (
  pagination,
  sortField,
  sortOrder,
  searchQueryData,
  id,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.get(
        `${Urls.GET_ALL_WAITING_LIST}/${id}?page=${pagination.page}&pageCount=${
          pagination.pageCount
        }&sortOrder=${commonSortOrder(
          sortOrder,
        )}&sortField=${sortField}&${searchQueryData}`,
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: GET_ALL_WAITING_LIST,
          payload: data?.data?.data,
        });
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};
export const getRegistrationUserWaitingListById = (id, userID) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.get(
        `${Urls.GET_ALL_USERS_WAITING_LIST}/${id}?page=1&pageCount=100&user_id=${userID}`,
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: GET_ALL_USER_WAITING_LIST,
          payload: data?.data?.data,
        });
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const updateFoodAndRegistrationOptions = (
  optionsData,
  id,
  setEditingKey,
  form,
  setDisableAttendeeClicks,
  setDisablePaymentClicks,
  setDisableEditClicks,
  onSuccess,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.patch(
        `${Urls.UPDATE_REGISTRATIONS_OPTIONS_BY_EVENTID}/${id}`,
        optionsData,
      );
      if (data?.status === HttpCode.Ok) {
        setEditingKey && setEditingKey('');
        form && form.resetFields();
        setDisableAttendeeClicks && setDisableAttendeeClicks(false);
        setDisablePaymentClicks && setDisablePaymentClicks(false);
        setDisableEditClicks && setDisableEditClicks(false);
        onSuccess && onSuccess();
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: SHOW_MESSAGE,
          payload: data?.data?.message,
        });
        dispatch({type: UPDATE_REGISTRATION_OPTOINS_BY_ID});
        dispatch({type: FETCH_EVENT_DATA});
        return {success: true};
      }
      return {success: false};
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.BadRequest:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Conflict:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      const errors = error?.response?.data?.errors;
      const isOverCapacityConfirmation =
        Array.isArray(errors) &&
        errors.includes('OVER_CAPACITY_CONFIRMATION_REQUIRED');

      if (isOverCapacityConfirmation) {
        dispatch({type: FETCH_SUCCESS});
        return {
          success: false,
          requiresOverCapacityConfirmation: true,
          errorMessage,
        };
      }

      dispatch({type: FETCH_ERROR, payload: errorMessage});
      return {
        success: false,
        requiresDuplicateConfirmation: error?.response?.status === HttpCode.Conflict,
        errorMessage,
      };
    }
  };
};

export const cancelEventRegistrationsByEventIds = (
  eventIds,
  setSelectedRowKeys,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let data = await httpClient.patch(
        Urls.CANCEL_GROUP_OF_EVENT_REGISTRATIONS_BY_EVENTID,
        eventIds,
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({
          type: SHOW_MESSAGE,
          payload: data?.data?.message,
        });
        dispatch({type: CANCEL_GROUP_OF_REGISTRATION_BY_EVENT_ID});
        setSelectedRowKeys && setSelectedRowKeys([]);
        return {
          success: true,
          spotOpened: Boolean(data?.data?.data?.spotOpened),
        };
      }
      return {success: false, spotOpened: false};
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      dispatch({type: FETCH_ERROR, payload: errorMessage});
      return {success: false, spotOpened: false};
    }
  };
};
// Success page state follows the API: PAID → registration complete; US ACH "processing" message → processing UI.
export const postEventPaymentSuccess = (data, navigate) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let response = await httpClient.patch(
        `${Urls.EVENT_POST_PAYMENT_SUCCESS}/${data?.type}`,
        data,
      );
      if (response.status === HttpCode.Ok) {
        dispatch({type: POST_EVENT_PAYMENT_SUCCESS});
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: SHOW_MESSAGE, payload: response?.data?.message});
        localStorage.removeItem('clientSecret');
        const path = `/paymentSuccess/myEvents/${
          data?.type === 'sponsor' ? 'sponsorship' : 'regular'
        }`;
        const message = response?.data?.message ?? '';
        const backendSaysProcessing =
          message.includes('being processed') &&
          message.includes('confirmed shortly');
        const statusForPage = backendSaysProcessing
          ? 'processing'
          : 'succeeded';
        navigate &&
          navigate(path, {
            state: {status: statusForPage},
          });
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        case HttpCode.Unauthorized:
          errorMessage = '';
          break;
        case HttpCode.Forbidden:
          errorMessage = error?.response?.data?.errorMessage;
          break;
        default:
          errorMessage = SOMETHING_WENT_WRONG;
          break;
      }
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const addNoteByEventRegistrationAPI = (payload) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      let response = await httpClient.patch(
        Urls.ADD_NOTE_BY_EVENT_REGISTRATION,
        {
          payload,
        },
      );
      if (response?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: SHOW_MESSAGE, payload: response?.data?.message});
        dispatch({type: ADD_NOTE_BY_EVENT_REGISTRATION_SUCCESS});
      }
    } catch (error) {
      let errorMessage = '';
      switch (error?.response?.status) {
        case HttpCode.InternalServerError:
          errorMessage = error?.response?.data?.errorMessage;
          break;
      }
      errorMessage = handleJwtExpireMsg(error, errorMessage);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

export const resetEventPayment = () => {
  return (dispatch) => {
    dispatch({type: RESET_EVENT_PAYMENT});
  };
};
export const memorizedInitiatedRefundAttendees = (
  selectedInitiateRefundIds,
) => {
  return (dispatch) => {
    dispatch({
      type: MEMORIZED_REFUND_ATTENDEES,
      payload: selectedInitiateRefundIds,
    });
  };
};
export const resetMemorizedInitiatedRefundAttendees = () => {
  return (dispatch) => {
    dispatch({type: RESET_MEMORIZED_REFUND_ATTENDEES});
  };
};

// ---- Vendor reps on an already-paid sponsorship (My Events) ----

const getApiErrorMessage = (error) => {
  switch (error?.response?.status) {
    case HttpCode.BadRequest:
      return (
        (error?.response?.data?.errorsValidation?.length
          ? Object.values(error.response.data.errorsValidation[0] || {})[0]
          : null) || error?.response?.data?.errorMessage
      );
    case HttpCode.NotFound:
    case HttpCode.Forbidden:
    case HttpCode.InternalServerError:
      return error?.response?.data?.errorMessage;
    case HttpCode.Unauthorized:
      return '';
    default:
      return SOMETHING_WENT_WRONG;
  }
};

/**
 * Adds vendor reps to a paid sponsorship (each linked via parent_sponsor_id). Reps are created one by
 * one so the API can enforce the free rep / perk limits; stops at the first failure.
 * Resolves to true when every rep was added.
 */
export const addRepsToPaidSponsorship = (reps) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      for (const rep of reps) {
        await httpClient.post(Urls.ADD_ATTENDEE, rep);
      }
      dispatch({type: FETCH_SUCCESS});
      return true;
    } catch (error) {
      const errorMessage = getApiErrorMessage(error);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
      return false;
    }
  };
};

/**
 * Pays for vendor reps waiting in the cart for a paid sponsorship. A $0 total is confirmed by the API
 * straight away; otherwise the user is sent to the Stripe checkout.
 */
export const payForSponsorReps = (
  eventId,
  optionId,
  navigate,
  parentSponsorId,
) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      rememberAddedRepsParent(parentSponsorId);
      const data = await httpClient.patch(
        Urls.PAYMENT_UPDATE_BY_EVENT_ID.replace('#{eventId}', eventId),
        {
          addProcessingFee: false,
          ...(parentSponsorId ? {parent_sponsor_id: parentSponsorId} : {}),
        },
      );
      if (data?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        const clientKeys = data?.data?.data?.clientSecret
          ? data.data.data
          : data?.data?.clientSecret
          ? data.data
          : data?.data?.data;
        if (clientKeys?.clientSecret) {
          dispatch({
            type: PAYMENT_EVENT_REGISTRATION_BY_EVENT_ID,
            payload: data?.data,
          });
          dispatch(setPaymentRoute(`eventSponsor`));
          dispatch({
            type: PAYMENT_EVENT_REGISTRATION_CLIENT_KEYS,
            payload: clientKeys,
          });
          navigate(`/payment/sponsor/${eventId}/${optionId}`);
        } else {
          navigate(`/paymentSuccess/myEvents/sponsorship`);
        }
      }
    } catch (error) {
      const errorMessage = getApiErrorMessage(error);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
    }
  };
};

/** Updates contact details of a vendor rep on a paid sponsorship. Resolves to true on success. */
export const updatePaidSponsorRep = (eventRegistrationId, data) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      const response = await httpClient.patch(
        Urls.UPDATE_ATTENDEE.replace(
          '#{eventRegistrationId}',
          eventRegistrationId,
        ),
        data,
      );
      if (response?.status === HttpCode.Ok) {
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: SHOW_MESSAGE, payload: response?.data?.message});
        return true;
      }
      return false;
    } catch (error) {
      const errorMessage = getApiErrorMessage(error);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
      return false;
    }
  };
};

/**
 * Loads one sponsorship for the "Add Vendor Reps" page: sponsor, package/perks, paid reps per payment
 * and reps added but not paid yet (with their total).
 */
export const getSponsorshipReps = (sponsorRegistrationId) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      const response = await httpClient.get(
        Urls.SPONSORSHIP_REPS.replace(
          '#{sponsorRegistrationId}',
          sponsorRegistrationId,
        ),
      );
      dispatch({type: FETCH_SUCCESS});
      return response?.data?.data;
    } catch (error) {
      dispatch({type: FETCH_ERROR, payload: getApiErrorMessage(error)});
      return null;
    }
  };
};

/** Removes a vendor rep that was added to a paid sponsorship but not paid yet. */
export const removePendingSponsorRep = (eventRegistrationId) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      await httpClient.delete(
        Urls.DELETE_ATTENDEE.replace(
          '#{eventRegistrationId}',
          eventRegistrationId,
        ),
      );
      dispatch({type: FETCH_SUCCESS});
      return true;
    } catch (error) {
      dispatch({type: FETCH_ERROR, payload: getApiErrorMessage(error)});
      return false;
    }
  };
};
